<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="500">
			<v-card>
				<v-card-title
					class="text-h5"
					style="background-color: red; color: white"
				>
					<v-icon left color="white">mdi-exclamation</v-icon> Confirm
					Deletion
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text align="center">
					<p class="title mt-10">Do you really want to delete?</p>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="green darken-1" text dark @click="close()">
						{{ $t("Close") }}
					</v-btn>

					<v-btn color="red darken-1" text @click="submit()">
						<v-icon left>mdi-delete</v-icon>
						{{ $t("Delete") }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
export default {
	props: {
		endpoint: {
			type: String,
			required: true,
		},
		id: {
			type: Number,
			required: false,
		},
	},
	data() {
		return {
			dialog: false,
		};
	},

	methods: {
		open() {
			this.dialog = true;
		},

		close() {
			this.dialog = false;
		},

		submit() {
			if (this.id) {
				this.$inertia.delete(this.$route(this.endpoint, this.id), {
					onFinish: () => this.close(),
				});
			}
		},
	},
};
</script>